import React from 'react';

/** Accent border colors cycling to match the media kit design mockup. */
export const MEDIA_KIT_INTEREST_ACCENT_COLORS = [
    '#a855f7', /* purple — Gaming */
    '#ec4899', /* pink — Culinary */
    '#22c55e', /* green — Entertainment */
    '#dc2626', /* red — Fine Arts */
    '#eab308', /* gold — Volleyball */
    '#14b8a6', /* teal — Animals */
    '#f97316', /* orange — Technology */
    '#38bdf8', /* sky — Travel */
] as const;

interface MediaKitInterestTagsProps {
    interests: string[];
}

export default function MediaKitInterestTags({ interests }: MediaKitInterestTagsProps) {
    if (interests.length === 0) {
        return <p className="media-kit-empty-copy">No interests added yet.</p>;
    }

    return (
        <div className="media-kit-interests-grid">
            {interests.map((interest, index) => (
                <span
                    key={`${interest}-${index}`}
                    className="media-kit-interest-tag"
                    style={{
                        borderColor: MEDIA_KIT_INTEREST_ACCENT_COLORS[index % MEDIA_KIT_INTEREST_ACCENT_COLORS.length],
                    }}
                >
                    {interest}
                </span>
            ))}
        </div>
    );
}
